// extracted by mini-css-extract-plugin
module.exports = {"error":"InlineError_error__2yAK5"};